import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ErrorBoundary from './ErrorLogging/ErrorBoundary';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/AppContainer';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import { loadReCaptcha } from 'react-recaptcha-v3';
import './index.css';
import "core-js/stable";
import "regenerator-runtime/runtime";
import { history } from 'redux-first-router';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { addCustomTagEvent } from './utilities/customTag';

const { store } = configureStore(window.REDUX_STATE);
history().listen(location => {
    addCustomTagEvent({
        event: 'pageView',
        page: {
            path: location.pathname
        }
    });
});

loadReCaptcha('6LccEpsUAAAAAMmvR8o6-0zC4D3EWU-A20MTefmI');

ReactDOM.render(
  <ErrorBoundary>
    <GoogleOAuthProvider clientId="828416645434-7nr0ck35kiq9b0cni2gdhu9e05ndodr4.apps.googleusercontent.com">
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  </ErrorBoundary>,
  document.getElementById('root')
);
